/**
 * Common user access validation methods used when building menu navigation
 * referenced server side in com.foretees.api.records.vueApp.enums.AppMenuAccess
 */

export default {
  any (vue) {
    return true
  },
}
